import * as headerBlock from '../header/';
import debounce from 'v-debounce';

const spinner = require('vue-strap').spinner;

export default {
  name: 'companies',
  components: { headerBlock, spinner },
  props: [
    'onLogout',
    'access_token',
    'authUser',
  ],
  mounted() {},
  data() {
    return {
      companiesFields: {
        index: {
          label: '#',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        name: {
          label: 'Company name',
          tdClass: 'text-left',
          thClass: 'text-center',
        },
        admin: {
          label: 'Company admin',
          tdClass: 'text-left',
          thClass: 'text-center',
        },
        phone: {
          label: 'Phone',
          // tdClass: 'text-left',
          thClass: 'text-center',
        },
        email: {
          label: 'Username',
          tdClass: 'text-left',
          thClass: 'text-center',
        },
        edit: {
          label: '',
          tdClass: 'text-left',
          thClass: 'text-center',
        },
      },
      companies: [],
      processLoading: false,
      filter: '',
    };
  },
  methods: {
    isInFilter(item) {
      return JSON.stringify(item).toLowerCase().indexOf(this.filter.toLowerCase()) + 1;
    },
    onAddCompany(e, id = null) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (id) {
        this.$router.push({ name: 'Change Company SuperUser', params: { companyId: id } });
      } else {
        this.$router.push({ name: 'Add Company SuperUser', params: { companyId: null } });
      }
    },
    onClickCompany(e, id) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.$router.push(`${process.env.START_URL}/company/${id}`);
    },
    getCompanies() {
      return this.$http.get('companies/',
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return null;
          }
          this.companies = response.body;
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
  },
  computed: {

  },
  created() {
    this.processLoading = true;
    this.getCompanies()
    .then(() => {
      this.processLoading = false;
    })
    .catch(() => {
      this.processLoading = false;
    });
  },
  directives: {
    debounce
  }
};



// WEBPACK FOOTER //
// ./src/components/companies/companies.component.js